export default __webpack_public_path__ + "static/media/YT1.46bb61b3.png";